// extracted by mini-css-extract-plugin
export var currencyInput = "_no-1";
export var currencySymbol = "_no-0";